// @flow

export const groupTypes = Object.freeze({
  Klass: 'Klass',
  DayCare: 'DayCare',
});

export type GroupType = $Values<typeof groupTypes>
